<template>
  <modal v-if="display">
    <div slot="body">
      To increase top of mind, we would like to be added to your homescreen
    </div>
    <div slot="footer">
      <h-btn @click="install" color="primary">Yes</h-btn>
      <h-btn @click="display=false" flat>Cancel</h-btn>
    </div>
  </modal>
</template>

<script>
import modal from "@/components/modal";
import Nazgul from "@/services/nazgul";

export default {
  components: {
    modal
  },
  data() {
    return {
      display: false
    };
  },
  created() {
    window.addEventListener("beforeinstallprompt", e => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later.
      this.deferredPrompt = e;
      this.display = true;
    });
  },
  methods: {
    install() {
      this.display = false;
      this.deferredPrompt.prompt();
      // TODO: add analytics
      Nazgul.report("webapp_install");
    }
  }
};
</script>
